import React from 'react'
import { Slider } from '../../../../components'
import {Terms} from "../../../../components/prints/utils";


export const TermsWithSlider = ({ clientName }: { clientName: string }) => {

    const terms = [
            'The  Customer  is  requested  to  receive  the  Service  Report via email  when  the  product  is  given  for  ' +
            'warranty/Out  of Warranty  repairs  at  Apple  Authorized  Service  Provider  (AASP)  and  the  Customer  must ' +
            ' verify  the  contents  of the Service Report before signature.',

            'Once you handover the Device to Service centre,  it will be deemed that you have given your consent to  ' +
            'Service Centre(s) to approach you and send communication/information to you regarding this services through ' +
            'call/SMS/email',

            'The  Customer  must  produce  the  Original  Service  Report over the registered mail at the time of taking the ' +
            `delivery. ${clientName} reserves the right to refuse delivery upon non production of the ' +
      'service report.`,

            `Physically damaged and liquid spilled  products if  received by ${clientName}  will  be  ` +
            'considered  as  Out  Of  Warranty  and  will  be  repaired/replaced  on a chargeable  basis & ' +
            `${clientName}  will  not  be  responsible  for  those  accidental  physical/liquid  ` +
            'damaged  parts/units  to  be  unresponsive during the diagnosing procedure.',

            'Any  kind  of  tampering/Unauthorized  modification  if  found  within  the  device,  the  service centre  ' +
            'reserves  the right to decline service for the same. Inspection/Diagnosis fee would be as applicable for ' +
            'such cases.',

            'You are advised to take data backup before handing over Device to the service centre or pick up agent. ' +
            'The Service Centre will not be responsible for any data loss during this service or repair. ' +
            `No claims of any sort shall be entertained against ${clientName}  Service Centre(s) ` +
            'with regard to data loss.',

            'You are advised to format the Device and also remove SIM card before handing it over to the Agent for ' +
            'service/repair. You are advised to turn off the FMI (Find my iPhone / Find my Mac) from your device' +
            ' before handing it over for service/repair.',

            'The  replacement  (if  applicable)  IOS  unit  offered  in  warranty/out  of  warranty  will  be  a ' +
            ' like  to  like  unit  replacement  only.  (i.e.  without  Box  Pack, accessories, Scratch  ' +
            'Guard  &  personal  engraving)  &  the  same  replaced  unit  or  the  replaced  spare  will ' +
            ' have  a  90  days  warranty  if  the  unit/device  is  out  of  warranty.  ' +
            'The  request once placed for spares (for the required repair) OR Unit replacement for ' +
            'IOS device if applicable shall not be cancelled.',

            'The  service  Centre  shall  take  utmost  care  while  handling  the  units  given  for  repair/service, ' +
            ' however  in  the event of any cosmetic issues service centre shall not be responsible for the same.',

            'The  charge  for  labour  as  well  as  spares  used  for  non-warranty  repair  shall  be  as  per  ' +
            'the  applicable  price  lists approved  and  recommended  by  Apple.  ' +
            'The  defective  parts  replaced  while  undertaking  the  repairs  of  the product under warranty ' +
            'will not be returned to the Customer.',

            `${clientName}   shall  make  all  efforts  to  ensure  that  the  product  is  repaired  within` +
            '  5  working days from the receipt of faulty product. At times however, due to non-availability/shortage of ' +
            'critical spares/  parts  or  complicated  fault,  the  repair  turn  around  time  may  take  longer  than ' +
            `indicated  while  accepting  the  machine  for  repair.  ${clientName}   will  not  be ` +
            ' responsible  for  any  loss/losses  whatsoever  in  the event of the delay in repair for such ' +
            'aforementioned reason.',

            `${clientName}   is  not  liable  for  any  delays,  non-performance, ` +
            ' failure  or  non-delivery  of  the  product  due  to  contingencies  arising  from  any  force ' +
            ' measure,  natural  calamities  like  storm,  earthquake,  accident  etc.  strikes,  lockout, ' +
            ' industrial  disputes,  labour  trouble,  transportations  embargo,  imminence  or  the  existence  of  any  ' +
            'state  emergency,  war,  civil  commotion  right,  communal  riots,  approval  or  imposition  of  ' +
            'sanctions  or  any  measure  taken  by  government  which  renders  it  impossible  or  impractical  ' +
            `for  ${clientName}  to perform supply, service or deliver the product to the customer.`,

            'The Estimate price given at the time of acceptance of the Product to repair is provisional and may vary after  ' +
            `detailed inspection and could be more than the final charges. ${clientName}  will proceed only ` +
            ' after taking the approval of the customer & payment confirmation.',

            'In the event the customer does not approve the final repair estimate within 7 days, the ' +
            'customer is requested  to have the device collected from the service centre at the earliest.',

            'The customer should take the delivery of the product within 30 days from the date after repair is completed ' +
            ' OR  Awaiting  Customer’s  Approval.  In  the  event  if  the  delivery  is  not  taken  by  the  Customer,  ' +
            `${clientName}  reserves the right to dispose/scrap the product to recover the repair/storage` +
            ' charges.',

            'Software based issues will be repaired on chargeable basis upon customer’s approval. By  accepting  ' +
            'the  service  report,  it  is  deemed  that  the Customer  agrees  to  all  the terms  and  ' +
            'condition  in  the  Service Report.',

            'Service Charges (Handling/ Inspection/Troubleshoot) will be Applicable for all Apple devices which are ' +
            'Out of Warranty as mentioned below.' +
            'Service Charges for IOS Devices(Watch , iPad, iPhone, Airpods) will be INR 1500/- ( including Taxes)' +
            'Service Charges for MAC Devices will be INR 3000/- (including Taxes)',

            `${clientName}  reserves the right to change/alter/modify/extend/annually modify any ` +
            'terms and conditions mentioned herein at any given point of time at its sole discretion and without any ' +
            'prior notice',

            'All legal matters under Delhi Jurisdiction.',
        ]
        return <>
       <small>{`By Clicking on the submit button, I accept, and agree to the ${clientName}'s terms and conditions.`
}</small>
    <Slider variant="link" title="Terms and conditions">
        <Terms label="Terms and conditions" value={terms}/>
    </Slider>
</>
}
